import React from 'react';

interface DeleteButtonProps {
  onDelete: () => Promise<void>;
  loading?: boolean;
  children?: React.ReactNode;
  className?: string;
  confirmMessage?: string;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
  onDelete,
  loading = false,
  children = 'Delete',
  className = '',
  confirmMessage = 'Are you sure you want to delete this item?',
}) => {
  const handleClick = async () => {
    if (!window.confirm(confirmMessage)) return;
    await onDelete();
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      className={`rounded-xl border border-[#8f3f39]/80 bg-[linear-gradient(135deg,#a64b43,#8c3f39)] px-4 py-2 font-medium tracking-[0.03em] text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#8c3f39] focus:outline-none focus:ring-2 focus:ring-red-500/30 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    >
      {loading ? 'Deleting...' : children}
    </button>
  );
};

export default DeleteButton;
